import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"width":"450px","height":"600px"} }
const _hoisted_5 = {
  key: 0,
  class: "p-field"
}
const _hoisted_6 = {
  key: 0,
  class: "p-field"
}
const _hoisted_7 = { class: "p-field-label mb-2 separator" }
const _hoisted_8 = { class: "p-field-radiobutton mb-3 separator" }
const _hoisted_9 = { for: "privateLabel" }
const _hoisted_10 = { class: "p-field-radiobutton mb-3 separator" }
const _hoisted_11 = { for: "businessLabel" }
const _hoisted_12 = {
  key: 1,
  class: "p-field"
}
const _hoisted_13 = {
  class: "p-field-label",
  for: "callingCode"
}
const _hoisted_14 = {
  key: 2,
  class: "p-field"
}
const _hoisted_15 = {
  class: "p-field-label",
  for: "surname"
}
const _hoisted_16 = {
  key: 3,
  class: "p-field"
}
const _hoisted_17 = {
  class: "p-field-label",
  for: "name"
}
const _hoisted_18 = {
  key: 4,
  class: "p-field"
}
const _hoisted_19 = {
  class: "p-field-label",
  for: "companyName"
}
const _hoisted_20 = {
  key: 5,
  class: "p-field"
}
const _hoisted_21 = { class: "col mb-3" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_23 = {
  class: "p-field-label",
  for: "image"
}
const _hoisted_24 = { class: "bt-icon bt-icon--xs" }
const _hoisted_25 = { class: "ml-2" }
const _hoisted_26 = {
  key: 0,
  class: "p-card m-2"
}
const _hoisted_27 = { class: "p-card-body" }
const _hoisted_28 = { class: "p-card-content d-flex justify-content-between align-items-center" }
const _hoisted_29 = { class: "bt-icon my-auto bt-icon--m" }
const _hoisted_30 = { class: "bt-icon bt-icon--m" }
const _hoisted_31 = { class: "card__head d-flex flex-column w-100" }
const _hoisted_32 = { class: "ml-3" }
const _hoisted_33 = { class: "m-0" }
const _hoisted_34 = { class: "p-field" }
const _hoisted_35 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_36 = {
  class: "p-field-label",
  for: "information"
}
const _hoisted_37 = { class: "bt-icon bt-icon--xs" }
const _hoisted_38 = { class: "ml-2" }
const _hoisted_39 = { class: "bt-icon bt-icon--xs" }
const _hoisted_40 = { class: "ml-2" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isVisible = $event)),
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom dialog-edit-label"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_ElScrollbar, null, {
            default: _withCtx(() => [
              (!_ctx.isBRFA)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    (!_ctx.isCallingCode)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.TypeUpper")), 1),
                          _createVNode("div", _hoisted_8, [
                            _createVNode(_component_RadioButton, {
                              id: "privateLabel",
                              name: "privateLabel",
                              value: true,
                              modelValue: _ctx.isPrivate,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPrivate = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.Private")), 1)
                          ]),
                          _createVNode("div", _hoisted_10, [
                            _createVNode(_component_RadioButton, {
                              id: "businessLabel",
                              name: "businessLabel",
                              value: false,
                              modelValue: _ctx.isPrivate,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPrivate = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("AppResourceEP.Business")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isCallingCode)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("AppResourceEP.CallingCode")), 1),
                          _createVNode(_component_InputText, {
                            id: "callingCode",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.callingCode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.callingCode = $event)),
                            maxlength: "25"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _createVNode("label", _hoisted_15, _toDisplayString(`${_ctx.$t("AppResourceEP.Line")} 1 (Max ${_ctx.maxLineFieldLength} ${_ctx.$t("AppResourceEP.Characters")})`), 1),
                          _createVNode(_component_InputText, {
                            id: "surname",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.surname,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.surname = $event)),
                            maxlength: "25"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_16, [
                          _createVNode("label", _hoisted_17, _toDisplayString(`${_ctx.$t("AppResourceEP.Line")} 2 (Max ${_ctx.maxLineFieldLength} ${_ctx.$t("AppResourceEP.Characters")})`), 1),
                          _createVNode(_component_InputText, {
                            id: "name",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.name,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.name = $event)),
                            maxlength: "25"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_18, [
                          _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AppResourceEP.CompanyName")), 1),
                          _createVNode(_component_InputText, {
                            id: "companyName",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.companyName,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.companyName = $event)),
                            maxlength: 40
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_20, [
                          _createVNode("div", _hoisted_21, [
                            _createVNode("div", _hoisted_22, [
                              _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("AppResourceEP.ImageUpper")), 1),
                              _createVNode("input", {
                                type: "file",
                                id: "fileInput",
                                style: {"display":"none"},
                                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                                accept: ".jpg, .jpeg"
                              }, null, 32),
                              _createVNode(_component_Button, {
                                class: "p-button-rounded p-button-outlined",
                                onClick: _ctx.triggerFilePicker,
                                disabled: _ctx.imageName != ''
                              }, {
                                default: _withCtx(() => [
                                  _createVNode("span", _hoisted_24, [
                                    _createVNode(_component_InlineSvgScoped, {
                                      src: 
                                                    require(`@/assets/images/icons/icon-plus-outline.svg`)
                                                ,
                                      "aria-label": "icon-grid"
                                    }, null, 8, ["src"])
                                  ]),
                                  _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ]),
                            _createVNode("label", null, _toDisplayString(_ctx.$t("AppResourceEP.NoImageAdded")), 1)
                          ]),
                          (_ctx.imageName != '')
                            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                                _createVNode("div", _hoisted_27, [
                                  _createVNode("div", _hoisted_28, [
                                    _createVNode("span", _hoisted_29, [
                                      _createVNode("span", _hoisted_30, [
                                        _createVNode(_component_InlineSvgScoped, {
                                          src: 
                                                        require(`@/assets/images/icons/icon_parameters_and_settings_folder_2.svg`)
                                                    ,
                                          "aria-label": "icon-badge"
                                        }, null, 8, ["src"])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_31, [
                                      _createVNode("div", _hoisted_32, [
                                        _createVNode("h4", _hoisted_33, _toDisplayString(_ctx.imageName), 1)
                                      ])
                                    ]),
                                    _createVNode(_component_Button, {
                                      class: "pl-0 mr-2 p-button-text",
                                      onClick: _ctx.removeImage
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("AppResourceEP.Information")), 1),
                  _createVNode(_component_Button, {
                    class: "p-button-rounded p-button-outlined",
                    onClick: _cache[8] || (_cache[8] = 
                                    () =>
                                        (_ctx.isInformationVisible = !_ctx.isInformationVisible)
                                )
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isInformationVisible)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("span", _hoisted_37, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                require(`@/assets/images/icons/icon-remove-outline.svg`)
                                            ,
                                "aria-label": "icon-grid"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _createVNode("span", _hoisted_39, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                require(`@/assets/images/icons/icon-plus-outline.svg`)
                                            ,
                                "aria-label": "icon-grid"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                          ], 64))
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.isInformationVisible)
                  ? (_openBlock(), _createBlock(_component_Textarea, {
                      key: 0,
                      id: "information",
                      class: "w-100 information-text-area",
                      modelValue: _ctx.information,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.information = $event)),
                      maxlength: 225
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.$t("entrancePlant.noInformationsAdded")), 1))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("footer", _hoisted_42, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-rounded p-button-raised p-button--m",
          onClick: _ctx.handleButtonSubmitAction,
          disabled: _ctx.saveButtonDisabled
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Save")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}